import { Navigate, Route } from "react-router-dom";
import {
    LeadReceiptsContactInformationOverview,
    ZipCodeInformationOverview
} from "../../features/waitingListBookingChangeRequest";
import { WohnenImAlterLeadOverview } from "features/leadProviders/wohnenImAlter";
import { DeutscheSeniorenPortalLeadOverview } from "features/leadProviders/deutscheSeniorenPortal";
import { AnfragenManagerCRMSupplierContainer } from "layout/components/AnfragenManagerCRMSupplierContainer";
import WaitingListLeadOverviewV1 from "features/leadProviders/waitingListLeadV1/components/WaitingListLeadOverviewV1";
import LeadOverview from "features/leadOverview/components/LeadOverview";
import CapacityLeadOverview from "features/leadProviders/capacityLead/componets/CapacityLeadOverview";
import EmailSettings from "features/leadProviders/waitingListLeadV1/components/Settings/EmailSetting";
// PhoneSettings
import PhoneSettings from "features/leadProviders/waitingListLeadV1/components/Settings/PhoneSettings";
// UserSettings
import UserSettings from "features/leadProviders/waitingListLeadV1/components/Settings/UserSettings";
// TaskManagement
import TaskManagement from "features/leadProviders/waitingListLeadV1/components/TaskManagement";
import TaskDetailOverview from "features/leadProviders/waitingListLeadV1/components/TaskDetailOverview";
import SalesManagement from "features/leadProviders/waitingListLeadV1/components/SalesManagement";
import WaitingListLeadOverviewV1Locked from "features/leadProviders/waitingListLeadV1/components/WaitingListLeadOverviewV1Locked";
import WaitingListLeadOverviewV1Erika from "features/leadProviders/waitingListLeadV1/components/WaitingListLeadOverviewV1Erika";
import LeadOverviewWon from "features/leadOverview/components/LeadOverviewWon";
import Timeline from "features/leadProviders/waitingListLeadV1/components/Roadmap/Timeline";
import ManagementKPIDashboard from "features/leadProviders/waitingListLeadV1/components/ManagementKPIDashboard";


import {
    ImportLeadCreateManually,
    ImportLeadOverview
} from "features/leadProviders/importLead";
import { BookingDetailsContainer } from "features/booking";

const AnfragenManagerCRMRoutes = (
    <>
        <Route path="/" element={<AnfragenManagerCRMSupplierContainer />}>
            <Route index element={<Navigate to="/leadOverview" replace />} />
            <Route path="/leadOverview" element={<LeadOverview />} />
            <Route
                path="/waiting-list-lead-details/:secureId"
                element={<WaitingListLeadOverviewV1 />}
            ></Route>
            <Route
                path="/waiting-list-lead-details/:secureId/contact"
                element={<LeadReceiptsContactInformationOverview />}
            ></Route>
            <Route
                path="/email-settings"
                element={<EmailSettings />}
            ></Route>
            <Route
                path="/phone-settings"
                element={<PhoneSettings />}
            ></Route>
            <Route
                path="/user-settings"
                element={<UserSettings />}
            ></Route>
            <Route path="/kpi-dashboard" element={<ManagementKPIDashboard />} />
            <Route
                path="/timeline"
                element={<Timeline />}
            ></Route>
            <Route
                path="/task-management"
                element={<TaskManagement />}
            ></Route>
            <Route
                path="/task-detail"
                element={<TaskDetailOverview />}
            ></Route>
            <Route
                path="/sales-management"
                element={<SalesManagement />}
            ></Route>
            <Route
                path="/waiting-list-lead-details/locked"
                element={<WaitingListLeadOverviewV1Locked />}
            ></Route>
            <Route
                path="/waiting-list-lead-details/erika"
                element={<WaitingListLeadOverviewV1Erika />}
            ></Route>
            <Route
                path="/leadOverview/won"
                element={<LeadOverviewWon />}
            ></Route>
            <Route
                path="/waiting-list-lead-details/:secureId/zip-code"
                element={<ZipCodeInformationOverview />}
            ></Route>
            <Route
                path="/waiting-list-lead-details/:secureId/:supplierId/booking"
                element={<BookingDetailsContainer />}
            ></Route>
            <Route
                path="/contact"
                element={<LeadReceiptsContactInformationOverview />}
            ></Route>
            <Route
                path=":supplierId/contact"
                element={<LeadReceiptsContactInformationOverview />}
            ></Route>
            <Route
                path="/zip-code"
                element={<ZipCodeInformationOverview />}
            ></Route>
            <Route
                path=":supplierId/zip-code"
                element={<ZipCodeInformationOverview />}
            ></Route>
            <Route
                path="/deutsche-senioren-portal-lead-details/:secureId"
                element={<DeutscheSeniorenPortalLeadOverview />}
            />
            <Route
                path="/wohnen-im-alter-lead-details/:secureId"
                element={<WohnenImAlterLeadOverview />}
            />
            <Route
                path="/capacity-lead-details/:secureId"
                element={<CapacityLeadOverview />}
            />
            <Route
                path="/capacity-lead-details/:secureId/:supplierId/booking"
                element={<BookingDetailsContainer />}
            ></Route>
            <Route
                path="/capacity-lead-details/:secureId/contact"
                element={<LeadReceiptsContactInformationOverview />}
            ></Route>
            <Route
                path="/capacity-lead-details/:secureId/zip-code"
                element={<ZipCodeInformationOverview />}
            ></Route>
            <Route
                path="/import-lead/create"
                element={<ImportLeadCreateManually />}
            ></Route>
            <Route
                path="/import-lead-details/:secureId"
                element={<ImportLeadOverview />}
            />
            <Route
                path="/:supplierId/booking"
                element={<BookingDetailsContainer />}
            ></Route>
            <Route
                path="/:supplierId/booking/:bookingId"
                element={<BookingDetailsContainer />}
            ></Route>
            <Route
                index
                path="/:supplierId"
                element={<Navigate to="booking" replace />}
            ></Route>
        </Route>
    </>
);

export default AnfragenManagerCRMRoutes;
